export const DRAWER_WIDTH = 220;
export const APPBAR_MOBILE = 64;
export const APPBAR_DESKTOP = 92;
